// eslint-disable-next-line import/prefer-default-export
export const GET_DELEGATED_OVERTIME_REQUESTS_SUCCESS =
  'GET_DELEGATED_OVERTIME_REQUESTS_SUCCESS';
export const GET_DELEGATED_OVERTIME_REQUESTS_ERROR =
  'GET_DELEGATED_OVERTIME_REQUESTS_ERROR';
export const GET_DELEGATED_OVERTIME_REQUESTS_PENDING =
  'GET_DELEGATED_OVERTIME_REQUESTS_PENDING';
export const SET_DELEGATED_OVERTIME_REQUESTS =
  'SET_DELEGATED_OVERTIME_REQUESTS';

export const GET_DELEGATED_TIME_ADJUSTMENT_REQUESTS_SUCCESS =
  'GET_DELEGATED_TIME_ADJUSTMENT_REQUESTS_SUCCESS';
export const GET_DELEGATED_TIME_ADJUSTMENT_REQUESTS_ERROR =
  'GET_DELEGATED_TIME_ADJUSTMENT_REQUESTS_ERROR';
export const GET_DELEGATED_TIME_ADJUSTMENT_REQUESTS_PENDING =
  'GET_DELEGATED_TIME_ADJUSTMENT_REQUESTS_PENDING';
export const SET_DELEGATED_TIME_ADJUSTMENT_REQUESTS =
  'SET_DELEGATED_TIME_ADJUSTMENT_REQUESTS';
export const SET_DELEGATED_DROPDOWN_FILTER_COUNTRY =
  'SET_DELEGATED_DROPDOWN_FILTER_COUNTRY';
